import { USERS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(USERS_ENDPOINT);
export default instance;
